import { Injectable } from '@angular/core';
import { HttpClient,HttpErrorResponse, HttpParams, HttpHeaders } from '@angular/common/http';
import { Observable, throwError} from 'rxjs';
import { map,catchError,delay } from 'rxjs/operators';
import { Invoice } from '../types/invoice';
import { EnvService } from '../services/env.service';

//const BASE_URL = "http://localhost:3000/invoices"; 
const httpOptions= {headers: new HttpHeaders({'Content-Type':'application/json'}) };

@Injectable({
  providedIn: 'root'
})
export class InvoiceService {


  constructor(private http: HttpClient,private env: EnvService ) { }

  getMaxId() :Observable <any[]>{
     return this.http.get<any[]>(`${this.env.apiUrl}/invoices/getMaxId`,httpOptions)
     .pipe(catchError(this.handleError));
        
     }

     getReturnNo() :Observable <any[]>{
      return this.http.get<any[]>(`${this.env.apiUrl}/invoices/getReturnNo`,httpOptions)
      .pipe(catchError(this.handleError));
         
      }

   getAll():Observable <any[]> {
    return this.http.get <any[]>(`${this.env.apiUrl}/invoices`,httpOptions)
    .pipe(catchError(this.handleError));
       
    }

    getAllQtySales():Observable <any[]> {
      return this.http.get <any[]>(`${this.env.apiUrl}/invoices/getAllQtySales`,httpOptions)
      .pipe(catchError(this.handleError));
         
    }

    getPurchaseItems(id):Observable <any> {
      return this.http.get <any>(`${this.env.apiUrl}/invoices/purchase-items/${id}`,httpOptions)
      .pipe(catchError(this.handleError));
         
    }
   

    getInvoice(invoiceNo):Observable <any> {
      return this.http.get<any>(`${this.env.apiUrl}/invoices/${invoiceNo}`,httpOptions)
      .pipe(catchError(this.handleError));
         
      }


    addInvoice(data):Observable <any>{
      return this.http.post<any>(`${this.env.apiUrl}/invoices`, data ,httpOptions)
        .pipe(catchError(this.handleError));
       
    }

    addCreditNote(data):Observable <any>{
      return this.http.post<any>(`${this.env.apiUrl}/invoices/creditNote`, data ,httpOptions)
        .pipe(catchError(this.handleError));
       
    }


    deleteInvoice(data,invoiceNo) : Observable <any>{
      return this.http.post<any>(`${this.env.apiUrl}/invoices/${invoiceNo}`,data,httpOptions)
        .pipe(catchError(this.handleError));
       
    }

    deleteCreditNote(data,invoiceNo) : Observable <any>{
      return this.http.post<any>(`${this.env.apiUrl}/invoices/creditNote/${invoiceNo}`,data,httpOptions)
        .pipe(catchError(this.handleError));
       
    }


    ////////////////////BAR INVOICE///////////////////////

    getBarMaxId() :Observable <any[]>{
      return this.http.get<any[]>(`${this.env.apiUrl}/invoices/getBarMaxId`,httpOptions)
      .pipe(catchError(this.handleError));
         
      }
 
  
 
     addBarInvoice(data):Observable <any>{
       return this.http.post<any>(`${this.env.apiUrl}/invoices/bar-invoice`, data ,httpOptions)
         .pipe(catchError(this.handleError));
        
     }
 
 
 

    private handleError(errorResponse: HttpErrorResponse) {
      return throwError(errorResponse || "Server Error");

      }       



}
